<div class="form-modal-wrapper">
  <div class="form-modal-header">
    <h4 class="modal-title">{{ template.name }}</h4>
    <button class="close-button" (click)="closeModal()" type="button" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <p *ngIf="template.description" class="form-modal-description">{{ template.description }}</p>
  </div>

  <div class="form-modal-body">
    <!-- Progress Indicator -->
    <div class="progress-container" style="margin-bottom: 20px;">
      <div class="progress-bar-wrapper" style="background: #e0e0e0; border-radius: 4px; height: 8px; overflow: hidden;">
        <div class="progress-bar" [style.width.%]="progressPercent"
          style="background: #4caf50; height: 100%; transition: width 0.3s ease;"></div>
      </div>
      <div class="progress-text" style="font-size: 12px; color: #666; margin-top: 4px;">
        {{ progressPercent }}% complete
      </div>
    </div>

    <div class="form-tabs" *ngIf="template.tabs.length > 1">
      <div class="row border-bottom mb-2">
        <div *ngFor="let tab of template.tabs; let i = index" class="col"
          [ngClass]="{ 'border-right': i < template.tabs.length - 1, 'mb-2': true }">
          <a class="tab-button" [ngClass]="{ 'active': currentTabIndex === i, 'has-errors': hasTabErrors(i) }"
            (click)="selectTab(i)">
            <p class="mb-0 lh-25 align-middle text-center"
              [ngClass]="{ 'font-weight-bold': currentTabIndex === i, 'font-weight': currentTabIndex !== i }">
              {{ tab.title }}
              <span *ngIf="hasTabErrors(i)" class="error-badge" style="margin-left: 4px; color: red;">
                ({{ getTabErrorCount(i) }})
              </span>
            </p>
          </a>
        </div>
      </div>
    </div>

    <form (ngSubmit)="onSubmit()" class="form-content">
      <div class="tab-content" *ngIf="currentTab">
        <div *ngFor="let field of currentTab.fields" class="field-wrapper">
          <app-form-text-field *ngIf="field.type === 'text'" [field]="field" [value]="getAnswerValue(field.id)"
            [readonly]="isViewMode"
            (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-text-field>

          <app-form-select-one-field *ngIf="field.type === 'select-one'" [field]="field"
            [value]="getAnswerValue(field.id)" (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-select-one-field>

          <app-form-select-multiple-field *ngIf="field.type === 'select-multiple'" [field]="field"
            [value]="getAnswerValue(field.id) || []" (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-select-multiple-field>

          <app-form-file-upload-field *ngIf="field.type === 'file'" [field]="field" [value]="getAnswerValue(field.id)"
            [organizationId]="organizationId" [projectId]="projectId" [taskId]="taskId" [customerId]="task?.customer"
            (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-file-upload-field>

          <app-form-picture-upload-field *ngIf="field.type === 'image'" [field]="field"
            [value]="getAnswerValue(field.id)" [organizationId]="organizationId" [projectId]="projectId"
            (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-picture-upload-field>

          <app-form-description-field *ngIf="field.type === 'description'" [field]="field"
            [value]="getAnswerValue(field.id)" (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-description-field>

          <app-form-image-display-field *ngIf="field.type === 'image-display'" [field]="field"
            [value]="getAnswerValue(field.id)" (valueChange)="setAnswer(field.id, $event)"
            (errorChange)="setFieldError(field.id, $event)"></app-form-image-display-field>
        </div>
      </div>
    </form>

    <div class="submit-error" *ngIf="submitError" style="color: red; margin-top: 1rem;">
      {{ submitError }}
    </div>
  </div>

  <div class="form-modal-footer">
    <div class="form-actions">
      <div class="draft-status" *ngIf="savingDraft">
        Auto-saving draft...
      </div>
      <div class="draft-status" *ngIf="!savingDraft && lastSavedAt">
        Last saved: {{ lastSavedAt | date:'shortTime' }}
      </div>
      <div class="row ml-0 mr-0" style="padding-left: 10%; padding-right: 10%; width: 100%;">
        <!-- Reset to Draft button (vendor/admin only, submitted forms only) -->
        <div class="col p-0 mr-2" *ngIf="isVendorUser && isViewMode">
          <button type="button" (click)="showResetToDraftConfirmation()" class="btn-reset w-100" [disabled]="resetting">
            <h6 class="btn-reset-text lh-20 p-1">
              {{ resetting ? 'Reopening...' : 'Reset to Draft' }}
            </h6>
          </button>
        </div>
        <div class="col p-0 mr-2">
          <button type="button" (click)="onSaveDraft()" class="btn-save w-100" [disabled]="submitting || isViewMode">
            <h6 class="btn-save-text lh-20 p-1">
              Save Draft
            </h6>
          </button>
        </div>
        <div class="col p-0 mr-2" *ngIf="template.tabs.length > 1">
          <button [disabled]="hasErrors() || currentTabIndex === 0 && template.tabs.length > 1 || submitting || isViewMode"
            (click)="previousTab()" class="btn btn-primary w-100">
            <h6 class="btn-text lh-20 p-1">
              ← Previous
            </h6>
          </button>
        </div>
        <div class="col p-0 mr-2" *ngIf="template.tabs.length > 1 && currentTabIndex < template.tabs.length - 1">
          <button [disabled]="hasErrors() || submitting || isViewMode" (click)="nextTab()" class="btn btn-primary w-100">
            <h6 class="btn-text lh-20 p-1">
              Next →
            </h6>
          </button>
        </div>
        <div class="col p-0" *ngIf="currentTabIndex === template.tabs.length - 1">
          <button type="submit" [disabled]="hasErrors() || submitting || isViewMode" (click)="onSubmit()" class="btn-save w-100">
            <h6 class="btn-save-text lh-20 p-1">
              {{ submitting ? 'Submitting...' : 'Submit' }}
            </h6>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Reset to Draft Confirmation Modal -->
  <div class="modal-overlay" *ngIf="showResetConfirmModal" (click)="closeResetConfirmModal()">
    <div class="reset-confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Reopen Form for Editing</h5>
        <button class="close-button" (click)="closeResetConfirmModal()" type="button" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>This will reopen the form for customer edits. Current submission will be preserved and can be modified.</p>
        <div class="reset-error" *ngIf="resetError" style="color: red; margin-top: 1rem;">
          {{ resetError }}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeResetConfirmModal()" [disabled]="resetting">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="onResetToDraft()" [disabled]="resetting">
          {{ resetting ? 'Reopening...' : 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</div>